import 'lodash'

export const prepareOptions = (items, value, text, idName = 'id') => {
	return _.map(items, function (item) {
		var option = {};
		option[idName] = item[value];
		option['text'] = item[text];
		return option;
	})
}

export const prependOptions = (options, text = 'Nenastaven') => {
	options.unshift({'id': 0, 'text': text})
	return [...options]
}

export const hasValue = (options, value) => {
	let found = false
	_.forEach(options, (option) => {
		if (String(option['id']) === String(value)) {
			found = true
		}
	})
	return found
}

export const getFirstValue = (items) => {
	return _.head(items)['id']
}

export const getTextByValue = (items, value) => {
	const found = _.find(items, function (item) {
		return String(item['id']) === String(value)
	})

	return found ? found['text'] : null
}

export const filterEntities = (entities, keys, substring, normalize = true) => {
	if (substring !== '') {
		if (normalize === true && typeof (String.prototype.normalize) !== 'function') {
			normalize = false
		}

		if (typeof substring !== 'string') {
			substring = castToString(substring)
		}

		if (!Array.isArray(keys)) {
			keys = [keys]
		}

		if (normalize) {
			entities = _.filter(entities, (entity) => {
				let found = false
				_.forEach(keys, (key) => {
					if (_.has(entity, key) && foundInStringNormalized(substring, castToString(entity[key]))) {
						found = true
					}
				})
				return found
			})
		} else {
			entities = _.filter(entities, (entity) => {
				let found = false
				_.forEach(keys, (key) => {
					if (_.has(entity, key) && foundInStringWithRegExp(substring, castToString(entity[key]))) {
						found = true
					}
				})
				return found
			})
		}
	}

	return entities
}

export const sortByKey = (values, key, direction = 'asc', normalize = false) => {
	return values.sort((a, b) => {
		let aValue = a[key]
		let bValue = b[key]

		if (normalize) {
			aValue = normalizeString(a[key])
			bValue = normalizeString(b[key])

			aValue = typeof aValue === "string" ? aValue.toLowerCase() : aValue;
			bValue = typeof bValue === "string" ? bValue.toLowerCase() : bValue;
		}

		let comparison = 0
		if (aValue > bValue) {
			comparison = 1
		} else if (aValue < bValue) {
			comparison = -1
		}

		return (direction === 'asc' ? comparison : comparison * -1)
	})
}

const castToString = (value) => {
	return typeof value !== 'string' ? String(value) : value
}

export const normalizeString = (string) => {
	return string.normalize('NFD').replace(/[\u0300-\u036f]/g, "")
}

export const normalizeStringLowercase = (string) => {
	return normalizeString(string).toLowerCase();
}

const foundInStringNormalized = (substring, string) => {
	const normalized = normalizeString(string)
	const normalizedFound = foundInStringWithRegExp(substring, normalized)

	return foundInStringWithRegExp(substring, string) || normalizedFound
}

const foundInStringWithRegExp = (substring, string) => {
	return string.search(new RegExp(substring, 'i')) !== -1
}

export const processCheckboxListToggle = (originalSelected, data) => {
	let selected = [...originalSelected]
	if (data.checked === true) {
		selected.push(data.id)
	} else {
		if (_.includes(selected, data.id)) {
			_.pull(selected, data.id)
		}
	}
	return selected
}

export const joinCombinedValues = (context, values) => {
	let joined = ''
	if (values.length > 0) {
		joined = _.join(
			_.map(values, function (value) {
				return getTextValueFromBooleanOrNull(context, value)
			}), ' / ')
	}

	return joined
}

export const getTextValueFromBooleanOrNull = (context, value) => {
	if (value === true) {
		return context.$gettext('Ano')
	}
	if (value === false) {
		return context.$gettext('Ne')
	}
	if (value === null) {
		return context.$gettext('Neurčeno')
	}
}

export const getCorrectBooleanValue = (value) => {
	if (value === 'true') {
		value = true
	}
	if (value === 'false') {
		value = false
	}
	return value
}

export const getBooleanOrNullListOptions = (context) => {
	return [
		{id: null, text: context.$gettext('Neurčeno')},
		{id: true, text: context.$gettext('Ano')},
		{id: false, text: context.$gettext('Ne')},
	]
}

export const formatNumber = (x) => {
	return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ");
}

export const removeAccents = (sourceString) => {
	return sourceString.toString().normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}

export const highlightText = (sourceText, highlightText, beforeTag='<b>', afterTag='</b>' ) =>{
	sourceText = sourceText.toString();
	highlightText = highlightText.toString();
	if(!sourceText.length || !highlightText.length){
		return sourceText;
	}
	let fromText = removeAccents(sourceText).toLowerCase();
	let toText = removeAccents(highlightText).toLowerCase();

	if(fromText.indexOf(toText) > -1){
		let fromPosition = fromText.indexOf(toText);
		let firstPart = sourceText.slice(0, fromPosition);
		let secondPart = sourceText.slice(fromPosition + toText.length);
		let highlightedText = beforeTag + sourceText.substring(fromPosition, fromPosition + toText.length) + afterTag;
		sourceText = firstPart+highlightedText+secondPart;
	}

	return sourceText;
}

export const downloadTableFile = (contents, filename, format = 'csv') => {
	let contentType;
	switch (format){
		case "xlsx":
			contentType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
			break;
		case "ods":
			contentType = 'application/vnd.oasis.opendocument.spreadsheet;charset=UTF-8';
			break;
		case "csv":
		default:
			contentType = 'text/csv; charset=UTF-8';
	}
	let blob = new Blob([contents], {type: contentType})
	let link = document.createElement('a')
	link.href = window.URL.createObjectURL(blob)
	const today = new Date()
	link.download = filename + '_' + today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate() + '.'+format
	link.click()
}

export const downloadFileXls = (contents, filename) => {
	let blob = new Blob([s2ab(atob(contents))], {type: 'application/vnd.ms-excel;charset=UTF-8;'})
	let link = document.createElement('a')
	link.href = window.URL.createObjectURL(blob)
	const today = new Date()
	link.download = filename + '_' + today.getFullYear() + '_' + (today.getMonth() + 1) + '_' + today.getDate() + '.xls'
	link.click()
}

const s2ab = (s) => {
	const buf = new ArrayBuffer(s.length)
	const view = new Uint8Array(buf)
	for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF
	return buf
}

export const iso6391ToIso6392 = (s) => {
	if(s === null){
		s = '';
	}
	const lang = s.toLowerCase()
	const array = getIso639Array()
	for (let i in array){
		if(array[i].iso6391 === lang) {
			return array[i].iso6392
		}
	}

	return ""
}

export const iso6392ToIso6391 = (s) => {
	const lang = s.toLowerCase()
	const array = getIso639Array()
	for (let i in array){
		if(array[i].iso6392 === lang) {
			return array[i].iso6391
		}
	}

	return ""
}

const getIso639Array = () => {
	return [
		{ iso6391 : 'cs', iso6392: 'cze'},
		{ iso6391 : 'de', iso6392: 'deu'},
		{ iso6391 : 'en', iso6392: 'eng'},
		{ iso6391 : 'sk', iso6392: 'slk'},
	]
}

export const arrayEquals = (a, b) =>{
	return Array.isArray(a) &&
		Array.isArray(b) &&
		a.length === b.length &&
		a.every((val, index) => val === b[index]);
}

export const getStateNameByIsoCode = (isoCode, context) => {
	let map =  stateIsoCodeToNameMap(context);
	return map.hasOwnProperty(isoCode) ? map[isoCode] : context.$gettext('Neznámý stát')
}

export const stateIsoCodeToNameMap = (context) => {
	return {
		'EUE': context.$gettext('Evropská unie'),
		'ABW': context.$gettext('Aruba'),
		'AFG': context.$gettext('Afghánistán'),
		'AGO': context.$gettext('Angola'),
		'AIA': context.$gettext('Anguilla'),
		'ALA': context.$gettext('Alandy'),
		'ALB': context.$gettext('Albánie'),
		'AND': context.$gettext('Andorra'),
		'ARE': context.$gettext('Spojené arabské emiráty'),
		'ARG': context.$gettext('Argentina'),
		'ARM': context.$gettext('Arménie'),
		'ASM': context.$gettext('Americká Samoa'),
		'ATA': context.$gettext('Antarktida'),
		'ATF': context.$gettext('Francouzská jižní a antarktická území'),
		'ATG': context.$gettext('Antigua a Barbuda'),
		'AUS': context.$gettext('Austrálie'),
		'AUT': context.$gettext('Rakousko'),
		'AZE': context.$gettext('Ázerbájdžán'),
		'BDI': context.$gettext('Burundi'),
		'BEL': context.$gettext('Belgie'),
		'BEN': context.$gettext('Benin'),
		'BES': context.$gettext('Bonaire, Sint Eustatius a Saba'),
		'BFA': context.$gettext('Burkina Faso'),
		'BGD': context.$gettext('Bangladéš'),
		'BGR': context.$gettext('Bulharsko'),
		'BHR': context.$gettext('Bahrajn'),
		'BHS': context.$gettext('Bahamy'),
		'BIH': context.$gettext('Bosna a Hercegovina'),
		'BLM': context.$gettext('Svatý Bartoloměj'),
		'BLR': context.$gettext('Bělorusko'),
		'BLZ': context.$gettext('Belize'),
		'BMU': context.$gettext('Bermudy'),
		'BOL': context.$gettext('Bolívie'),
		'BRA': context.$gettext('Brazílie'),
		'BRB': context.$gettext('Barbados'),
		'BRN': context.$gettext('Brunej'),
		'BTN': context.$gettext('Bhútán'),
		'BVT': context.$gettext('Bouvetův ostrov'),
		'BWA': context.$gettext('Botswana'),
		'CAF': context.$gettext('Středoafrická republika'),
		'CAN': context.$gettext('Kanada'),
		'CCK': context.$gettext('Kokosové ostrovy'),
		'CHE': context.$gettext('Švýcarsko'),
		'CHL': context.$gettext('Chile'),
		'CHN': context.$gettext('Čína'),
		'CIV': context.$gettext('Pobřeží slonoviny'),
		'CMR': context.$gettext('Kamerun'),
		'COD': context.$gettext('Demokratická republika Kongo'),
		'COG': context.$gettext('Konžská republika'),
		'COK': context.$gettext('Cookovy ostrovy'),
		'COL': context.$gettext('Kolumbie'),
		'COM': context.$gettext('Komory'),
		'CPV': context.$gettext('Kapverdy'),
		'CRI': context.$gettext('Kostarika'),
		'CUB': context.$gettext('Kuba'),
		'CUW': context.$gettext('Curaçao'),
		'CXR': context.$gettext('Vánoční ostrov'),
		'CYM': context.$gettext('Kajmanské ostrovy'),
		'CYP': context.$gettext('Kypr'),
		'CZE': context.$gettext('Česká republika'),
		'DEU': context.$gettext('Německo'),
		'DJI': context.$gettext('Džibutsko'),
		'DMA': context.$gettext('Dominika'),
		'DNK': context.$gettext('Dánsko'),
		'DOM': context.$gettext('Dominikánská republika'),
		'DZA': context.$gettext('Alžírsko'),
		'ECU': context.$gettext('Ekvádor'),
		'EGY': context.$gettext('Egypt'),
		'ERI': context.$gettext('Eritrea'),
		'ESH': context.$gettext('Západní Sahara'),
		'ESP': context.$gettext('Španělsko'),
		'EST': context.$gettext('Estonsko'),
		'ETH': context.$gettext('Etiopie'),
		'FIN': context.$gettext('Finsko'),
		'FJI': context.$gettext('Fidži'),
		'FLK': context.$gettext('Falklandy'),
		'FRA': context.$gettext('Francie'),
		'FRO': context.$gettext('Faerské ostrovy'),
		'FSM': context.$gettext('Mikronésie'),
		'GAB': context.$gettext('Gabon'),
		'GBR': context.$gettext('Spojené království'),
		'GEO': context.$gettext('Gruzie'),
		'GGY': context.$gettext('Guernsey'),
		'GHA': context.$gettext('Ghana'),
		'GIB': context.$gettext('Gibraltar'),
		'GIN': context.$gettext('Guinea'),
		'GLP': context.$gettext('Guadeloupe'),
		'GMB': context.$gettext('Gambie'),
		'GNB': context.$gettext('Guinea-Bissau'),
		'GNQ': context.$gettext('Rovníková Guinea'),
		'GRC': context.$gettext('Řecko'),
		'GRD': context.$gettext('Grenada'),
		'GRL': context.$gettext('Grónsko'),
		'GTM': context.$gettext('Guatemala'),
		'GUF': context.$gettext('Francouzská Guyana'),
		'GUM': context.$gettext('Guam'),
		'GUY': context.$gettext('Guyana'),
		'HKG': context.$gettext('Hongkong'),
		'HMD': context.$gettext('Heardův ostrov a McDonaldovy ostrovy'),
		'HND': context.$gettext('Honduras'),
		'HRV': context.$gettext('Chorvatsko'),
		'HTI': context.$gettext('Haiti'),
		'HUN': context.$gettext('Maďarsko'),
		'IDN': context.$gettext('Indonésie'),
		'IMN': context.$gettext('Ostrov Man'),
		'IND': context.$gettext('Indie'),
		'IOT': context.$gettext('Britské indickooceánské území'),
		'IRL': context.$gettext('Irsko'),
		'IRN': context.$gettext('Írán'),
		'IRQ': context.$gettext('Irák'),
		'ISL': context.$gettext('Island'),
		'ISR': context.$gettext('Izrael'),
		'ITA': context.$gettext('Itálie'),
		'JAM': context.$gettext('Jamajka'),
		'JEY': context.$gettext('Jersey'),
		'JOR': context.$gettext('Jordánsko'),
		'JPN': context.$gettext('Japonsko'),
		'KAZ': context.$gettext('Kazachstán'),
		'KEN': context.$gettext('Keňa'),
		'KGZ': context.$gettext('Kyrgyzstán'),
		'KHM': context.$gettext('Kambodža'),
		'KIR': context.$gettext('Kiribati'),
		'KNA': context.$gettext('Svatý Kryštof a Nevis'),
		'KOR': context.$gettext('Jižní Korea'),
		'KWT': context.$gettext('Kuvajt'),
		'LAO': context.$gettext('Laos'),
		'LBN': context.$gettext('Libanon'),
		'LBR': context.$gettext('Libérie'),
		'LBY': context.$gettext('Libye'),
		'LCA': context.$gettext('Svatá Lucie'),
		'LIE': context.$gettext('Lichtenštejnsko'),
		'LKA': context.$gettext('Srí Lanka'),
		'LSO': context.$gettext('Lesotho'),
		'LTU': context.$gettext('Litva'),
		'LUX': context.$gettext('Lucembursko'),
		'LVA': context.$gettext('Lotyšsko'),
		'MAC': context.$gettext('Macao'),
		'MAF': context.$gettext('Saint-Martin'),
		'MAR': context.$gettext('Maroko'),
		'MCO': context.$gettext('Monako'),
		'MDA': context.$gettext('Moldavsko'),
		'MDG': context.$gettext('Madagaskar'),
		'MDV': context.$gettext('Maledivy'),
		'MEX': context.$gettext('Mexiko'),
		'MHL': context.$gettext('Marshallovy ostrovy'),
		'MKD': context.$gettext('Severní Makedonie'),
		'MLI': context.$gettext('Mali'),
		'MLT': context.$gettext('Malta'),
		'MMR': context.$gettext('Myanmar'),
		'MNE': context.$gettext('Černá Hora'),
		'MNG': context.$gettext('Mongolsko'),
		'MNP': context.$gettext('Severní Mariany'),
		'MOZ': context.$gettext('Mosambik'),
		'MRT': context.$gettext('Mauritánie'),
		'MSR': context.$gettext('Montserrat'),
		'MTQ': context.$gettext('Martinik'),
		'MUS': context.$gettext('Mauricius'),
		'MWI': context.$gettext('Malawi'),
		'MYS': context.$gettext('Malajsie'),
		'MYT': context.$gettext('Mayotte'),
		'NAM': context.$gettext('Namibie'),
		'NCL': context.$gettext('Nová Kaledonie'),
		'NER': context.$gettext('Niger'),
		'NFK': context.$gettext('Norfolk'),
		'NGA': context.$gettext('Nigérie'),
		'NIC': context.$gettext('Nikaragua'),
		'NIU': context.$gettext('Niue'),
		'NLD': context.$gettext('Nizozemsko'),
		'NOR': context.$gettext('Norsko'),
		'NPL': context.$gettext('Nepál'),
		'NRU': context.$gettext('Nauru'),
		'NZL': context.$gettext('Nový Zéland'),
		'OMN': context.$gettext('Omán'),
		'PAK': context.$gettext('Pákistán'),
		'PAN': context.$gettext('Panama'),
		'PCN': context.$gettext('Pitcairnovy ostrovy'),
		'PER': context.$gettext('Peru'),
		'PHL': context.$gettext('Filipíny'),
		'PLW': context.$gettext('Palau'),
		'PNG': context.$gettext('Papua-Nová Guinea'),
		'POL': context.$gettext('Polsko'),
		'PRI': context.$gettext('Portoriko'),
		'PRK': context.$gettext('Severní Korea'),
		'PRT': context.$gettext('Portugalsko'),
		'PRY': context.$gettext('Paraguay'),
		'PSE': context.$gettext('Palestina'),
		'PYF': context.$gettext('Francouzská Polynésie'),
		'QAT': context.$gettext('Katar'),
		'REU': context.$gettext('Réunion'),
		'ROU': context.$gettext('Rumunsko'),
		'RUS': context.$gettext('Rusko'),
		'RWA': context.$gettext('Rwanda'),
		'SAU': context.$gettext('Saúdská Arábie'),
		'SDN': context.$gettext('Súdán'),
		'SEN': context.$gettext('Senegal'),
		'SGP': context.$gettext('Singapur'),
		'SGS': context.$gettext('Jižní Georgie a Jižní Sandwichovy ostrovy'),
		'SHN': context.$gettext('Svatá Helena'),
		'SJM': context.$gettext('Špicberky a Jan Mayen'),
		'SLB': context.$gettext('Šalomounovy ostrovy'),
		'SLE': context.$gettext('Sierra Leone'),
		'SLV': context.$gettext('Salvador'),
		'SMR': context.$gettext('San Marino'),
		'SOM': context.$gettext('Somálsko'),
		'SPM': context.$gettext('Saint Pierre a Miquelon'),
		'SRB': context.$gettext('Srbsko'),
		'SSD': context.$gettext('Jižní Súdán'),
		'STP': context.$gettext('Svatý Tomáš a Princův ostrov'),
		'SUR': context.$gettext('Surinam'),
		'SVK': context.$gettext('Slovensko'),
		'SVN': context.$gettext('Slovinsko'),
		'SWE': context.$gettext('Švédsko'),
		'SWZ': context.$gettext('Eswatini'),
		'SXM': context.$gettext('Svatý Martin'),
		'SYC': context.$gettext('Seychely'),
		'SYR': context.$gettext('Sýrie'),
		'TCA': context.$gettext('Turks a Caicos'),
		'TCD': context.$gettext('Čad'),
		'TGO': context.$gettext('Togo'),
		'THA': context.$gettext('Thajsko'),
		'TJK': context.$gettext('Tádžikistán'),
		'TKL': context.$gettext('Tokelau'),
		'TKM': context.$gettext('Turkmenistán'),
		'TLS': context.$gettext('Východní Timor'),
		'TON': context.$gettext('Tonga'),
		'TTO': context.$gettext('Trinidad a Tobago'),
		'TUN': context.$gettext('Tunisko'),
		'TUR': context.$gettext('Turecko'),
		'TUV': context.$gettext('Tuvalu'),
		'TWN': context.$gettext('Tchaj-wan'),
		'TZA': context.$gettext('Tanzanie'),
		'UGA': context.$gettext('Uganda'),
		'UKR': context.$gettext('Ukrajina'),
		'UMI': context.$gettext('Menší odlehlé ostrovy USA'),
		'URY': context.$gettext('Uruguay'),
		'USA': context.$gettext('Spojené státy americké'),
		'UZB': context.$gettext('Uzbekistán'),
		'VAT': context.$gettext('Vatikán'),
		'VCT': context.$gettext('Svatý Vincenc a Grenadiny'),
		'VEN': context.$gettext('Venezuela'),
		'VGB': context.$gettext('Britské Panenské ostrovy'),
		'VIR': context.$gettext('Americké Panenské ostrovy'),
		'VNM': context.$gettext('Vietnam'),
		'VUT': context.$gettext('Vanuatu'),
		'WLF': context.$gettext('Wallis a Futuna'),
		'WSM': context.$gettext('Samoa'),
		'YEM': context.$gettext('Jemen'),
		'ZAF': context.$gettext('Jihoafrická republika'),
		'ZMB': context.$gettext('Zambie'),
		'ZWE': context.$gettext('Zimbabwe')
	}
};



// WEBPACK FOOTER //
// ./src/utils/helpers.js